import styled from "styled-components";

export const StyledChatbotPopup = styled.div`
  position: fixed;
  width: 40rem;
  height: 50rem;

  min-width: 20rem;
  max-width: 80rem;
  min-height: 20rem;
  max-height: 80rem;

  background-color: var(--bg-gray-0);
  border-radius: 0.8rem;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
  z-index: 10000;
  display: flex;
  flex-direction: column;

  transform: translate(-50%, -50%);

  .top-handle,
  .left-handle,
  .right-handle,
  .bottom-handle,
  .top-left-handle,
  .top-right-handle,
  .bottom-left-handle,
  .bottom-right-handle {
    position: absolute;

    &.top-handle {
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      height: 2px;
      cursor: ns-resize;
    }

    &.left-handle {
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      height: 100%;
      width: 2px;
      cursor: ew-resize;
    }

    &.right-handle {
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      height: 100%;
      width: 2px;
      cursor: ew-resize;
    }

    &.bottom-handle {
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      height: 2px;
      cursor: ns-resize;
    }

    &.top-left-handle {
      top: 0;
      left: 0;
      width: 4px;
      height: 4px;
      cursor: nwse-resize;
    }

    &.top-right-handle {
      top: 0;
      right: 0;
      width: 4px;
      height: 4px;
      cursor: nesw-resize;
    }

    &.bottom-left-handle {
      bottom: 0;
      left: 0;
      width: 4px;
      height: 4px;
      cursor: nesw-resize;
    }

    &.bottom-right-handle {
      bottom: 0;
      right: 0;
      width: 4px;
      height: 4px;
      cursor: nwse-resize;
    }
  }

  header {
    width: 100%;
    box-sizing: border-box;
    height: 4rem;
    background-color: var(--bg-gray-5);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.6rem;
    &:hover {
      cursor: move;
    }
    h1 {
      font: var(--body-medium-600);
      color: var(--text-gray-normal);
      display: flex;
      align-items: center;
      gap: 0.8rem;
    }
  }
  main {
    box-sizing: border-box;
    padding: 1.6rem;
    flex: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  footer {
    background-color: var(--bg-gray-normal);
    min-height: 4rem;
    max-height: 10rem;
    border-top: 1px solid var(--bg-gray-2);
    display: flex;
    align-items: flex-end;
    gap: 0.4rem;
    padding: 0.8rem;

    .ai-button:not(:disabled) {
      position: relative;
      overflow: hidden;
      border: 0;
      svg {
        position: relative;
        z-index: 10;
      }
      &::after {
        position: absolute;
        z-index: 5;
        content: "";
        width: 150%;
        height: 150%;
        top: 50%;
        left: 50%;
        background: linear-gradient(
          0deg,
          rgb(131, 176, 251) 0%,
          rgb(32, 100, 246) 60%,
          rgb(19, 63, 158) 100%
        );
        animation: rotate 5s infinite linear;
        z-index: 1;
      }
    }
  }
`;
